import { ReactElement } from 'react'
import styled from 'styled-components'
import BatteryFullIcon from '@mui/icons-material/BatteryFull'
import Divider from '@mui/material/Divider'
import { breakpoints } from '../../../../../src/theme/breakpoints'

interface CondensedSettingsViewProps {
  isCondensed: boolean
}

export const CondensedSettingsView = ({
  isCondensed,
}: CondensedSettingsViewProps): ReactElement => {
  const CondensedViewSection = (): ReactElement => (
    <CondensedView isCondensed={isCondensed}>
      <StyledBatteryFullIcon />
      <LineView />
      <LineView />
      <LineView />
      <DashViewContainer>
        <DashView />
      </DashViewContainer>
    </CondensedView>
  )

  return (
    <MainContainer>
      <Container>
        <CondensedViewSection />
        <Divider
          sx={{
            width: '100%',
            backgroundColor: '#d3d2cf',
          }}
        />
        <CondensedViewSection />
        <Divider
          sx={{
            width: '100%',
            backgroundColor: '#d3d2cf',
          }}
        />
        <CondensedViewSection />
      </Container>
    </MainContainer>
  )
}

const MainContainer = styled.div`
  height: auto;
  width: 240px;
  border: 1px solid #d3d2cf;
  border-radius: 10px;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 177px;
  }
`

const Container = styled.div``

interface CondensedViewProps {
  isCondensed?: boolean
}

const CondensedView = styled.div<CondensedViewProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${(props) => (props.isCondensed ? `2px` : `6px`)};
  margin-bottom: ${(props) => (props.isCondensed ? `2px` : `6px`)};
  margin-right: 5px;
  margin-left: 5px;
`

const LineView = styled.div`
  width: 100px;
  height: 4px;
  background-color: #6b6b6b;
  border-radius: 4px;
  margin-left: 5px;
  margin-right: 5px;
`
const DashView = styled.div`
  width: 10px;
  height: 1.5px;
  background-color: #000000;
`

const DashViewContainer = styled.div`
  width: 48px;
  height: 8px;
  background-color: #f9c100;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledBatteryFullIcon = styled(BatteryFullIcon)`
  width: 16px;
  height: 16px;
`
